import {RestResource} from "../rest";
import {TICKET_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const ticket = new RestResource({server: TICKET_SERVER, resource: 'ticket'});

/**
 * 事件接单率统计
 * @param params
 * @returns {Promise<unknown>}
 */
ticket.fetchOnTimeTicketOrderTake = (params) => {
    let url = `${TICKET_SERVER}/tickets/onTimeOrderTake`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * 事件等级统计
 * @param params
 * @returns {Promise<unknown>}
 */
ticket.queryTicketLevelInfo = (params) => {
    let url = `${TICKET_SERVER}/management/charts`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.data.code == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

ticket.findSimpleIncidentByLogbook = (params) => {
    let url = `${TICKET_SERVER}/incident/byLogbook/simple`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.data.code === 200) {
                resolve(responseBody.data.data);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

ticket.countIncidentByLogbook = (params) => {
    let url = `${TICKET_SERVER}/incident/countForLogbook`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

ticket.submit = (params) => {
    let url = `${TICKET_SERVER}/ticket/submit`;
    return new Promise((resolve, reject) => {
        athubAxios.postByMultipartForm(url, params).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

ticket.list = (params) => {
    return athubAxios.postByForm(`${TICKET_SERVER}/ticketsAll`, params)
};

ticket.monthlyFinishRate = (days) => {
    return athubAxios.get(`${TICKET_SERVER}/tickets/monthlyFinishRate/${days}`);
};

ticket.accept = (id, body) => {
    let url = `${TICKET_SERVER}/ticket/ticketToWorkFlowAccept/INCIDENT/${id}`;
    return new Promise((resolve, reject) => {
        athubAxios.postByJson(url, body).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data);
            } else {
                let message = responseBody.data.message;
                if (message != null) {
                    message = message.replace('失败！失败原因：系统错误，请联系管理员', '');
                }
                reject(message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

ticket.page = (params) => {
    let url = `${TICKET_SERVER}/tickets`;
    return athubAxios.postByMultipartForm(url, params);
};

ticket.batchKillOrder = (params) => {
    let url = `${TICKET_SERVER}/ticket/batchKillOrder`;
    return athubAxios.postByMultipartForm(url, params);
}

export default ticket;
